import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'

const CardSpecimenLogUX = (props: any) => {
    return(
      <div>
        <div
          style={{padding: "10px", fontSize: "1.6rem", fontWeight: "bold" }}>
          {props.languageUX === "en" ? "Work history" : "ประวัติการทำงาน"}
          <div>
            
            <Table
              data={props.specimenLogs}
              headers="User,Action,Collector,Collector Division,Note,Date-time"
              keys="name,action,collector_name,collector_div_name,note,datetime"
              showPagination={false}
              style={{height: "300px", margin: "10px",fontSize: "1.2rem", fontWeight: "normal"}}
              widths="200,200,auto,auto,auto,200">
            </Table>
          </div>
        </div>
      </div>
    )
}


export default CardSpecimenLogUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการทำงาน",
          "valueEN": "Work history"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", fontSize: \"1.6rem\", fontWeight: \"bold\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "data": {
          "type": "code",
          "value": "props.specimenLogs"
        },
        "headers": {
          "type": "value",
          "value": "User,Action,Collector,Collector Division,Note,Date-time"
        },
        "keys": {
          "type": "value",
          "value": "name,action,collector_name,collector_div_name,note,datetime"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\", margin: \"10px\",fontSize: \"1.2rem\", fontWeight: \"normal\"}"
        },
        "widths": {
          "type": "value",
          "value": "200,200,auto,auto,auto,200"
        }
      },
      "seq": 3,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSpecimenLogUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
